import { observable, action } from 'mobx'

class ConfirmPasswordStore {
  @observable code = ''
  @observable password = ''
  @observable passwordRepeat = ''
  @observable passwordMessage

  @action.bound setCode(code) {
    this.code = code
  }

  @action.bound setPassword(password) {
    this.password = password
  }

  @action.bound setPasswordRepeat(passwordRepeat) {
    this.passwordRepeat = passwordRepeat
  }

  @action.bound setPasswordMessage(passwordMessage) {
    this.passwordMessage = passwordMessage
  }
}

export default new ConfirmPasswordStore()



// WEBPACK FOOTER //
// ./src/stores/confirmAccountStore.js